import React, { useState } from 'react';
import { flip, offset, useFloating } from '@floating-ui/react-dom';
import { SketchPicker } from 'react-color';
import { Portal } from '../Portal/index.js';
import { Tooltip } from '../Tooltip/index.js';
import { ColorCircle } from './ColorCircle.js';
export const ColorPicker = ({ color, onChange, tooltip, size = 'md', variants = [], invalid = false, disabled = false, }) => {
    const [show, setShow] = useState(false);
    const { x, y, reference, floating, strategy } = useFloating({
        placement: 'bottom-end',
        middleware: [offset(4), flip()],
    });
    const circleMarkup = (React.createElement(ColorCircle, { size: size, color: color, invalid: invalid, ref: reference, onClick: !disabled ? () => setShow(true) : undefined }));
    const circleTitleMarkup = tooltip && !show ? (React.createElement(Tooltip, null,
        React.createElement(Tooltip.Trigger, { className: "inline-block" }, circleMarkup),
        React.createElement(Tooltip.Panel, null, tooltip))) : (circleMarkup);
    return (React.createElement("div", { className: "relative" },
        circleTitleMarkup,
        React.createElement(Portal, null,
            React.createElement("div", null, show && (React.createElement("div", { className: "absolute" },
                React.createElement("div", { className: "fixed top-0 end-0 start-0 bottom-0", onClick: () => setShow(false) }),
                React.createElement("div", { ref: floating, style: {
                        position: strategy,
                        top: '0',
                        left: '0',
                        transform: `translate(${Math.round(x)}px,${Math.round(y)}px)`,
                    }, onKeyPress: e => {
                        if (e.key === 'Enter') {
                            setShow(false);
                        }
                    } },
                    React.createElement(SketchPicker, { color: color, onChange: result => onChange(result.hex), disableAlpha: true, presetColors: variants }))))))));
};
//# sourceMappingURL=ColorPicker.js.map